import React from 'react'
import Skeleton from 'react-loading-skeleton'

import 'react-loading-skeleton/dist/skeleton.css'

type PropsWhiteSkeleton = {
  height?: string
  width?: string
  borderRadius?: string
}

export const whiteSkeleton = ({
  height = '18px',
  width,
  borderRadius = '20px',
}: PropsWhiteSkeleton): JSX.Element => {
  const jadeGray = '#D7DBE0'
  const highlightJadeGray = '#e1e6ec'

  return (
    <>
      <Skeleton
        baseColor={jadeGray}
        highlightColor={highlightJadeGray}
        borderRadius={borderRadius}
        height={height}
        width={width}
      />
    </>
  )
}
